export const AV_FALLBACK = (e) => {
  e.currentTarget.onerror = null;
  e.currentTarget.src = "https://ui-avatars.com/api/?background=0A4D3C&color=ffffff&bold=true&name=" + encodeURIComponent(e.currentTarget.alt || "مستخدم");
};

export function CircularProgress({ value = 0, size = 120, stroke = 10, color = "#006654", label }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (value / 100) * c;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#d0d8dd" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }} />
      </svg>
      <div className="absolute text-center">
        <div className="text-2xl font-extrabold text-[#006654]">{Math.round(value)}%</div>
        {label && <div className="text-xs text-gray-500">{label}</div>}
      </div>
    </div>
  );
}

export function LinearProgress({ value = 0, color = "#006654" }) {
  return (
    <div className="w-full h-2.5 rounded-full bg-[#d0d8dd] overflow-hidden">
      <div className="h-full rounded-full" style={{ width: `${value}%`, background: color, transition: "width 0.5s ease" }} />
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, accent = "#006654", testid }) {  return (
    <div data-testid={testid} className="bg-white rounded-2xl border border-[#d0d8dd] p-5 shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:-translate-y-1 transition-transform">
      <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-3" style={{ background: `${accent}15`, color: accent }}>
        <Icon size={22} />
      </div>
      <div className="text-2xl font-extrabold text-[#1A1A1A]">{value}</div>
      <div className="text-sm text-gray-500 mt-1">{label}</div>
    </div>
  );
}
